import React, { Component } from 'react';
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
import { Alert, Confirm } from "../../../js/ComponentManager";

/* 개발담당:양유빈
 * 화면기능:회원탈퇴
 * 세부설명:
*/

export class Withdrawal extends Component {
    static displayName = Withdrawal.name;

    constructor(props) {
        super(props);
        this.state = {
            Confirm_Yn: false,
            Content:""
        };
        this.handleWithdrawal_Click = this.handleWithdrawal_Click.bind(this);
        this.handleAlert_Click = this.handleAlert_Click.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMove_Click = this.handleMove_Click.bind(this);
        this.RegisterSuccess = false;
    }
    //초기화
    componentDidMount() {
        this.CallWithdrawlMessageData();
    }

    async CallWithdrawlMessageData() {
        try {
            let Data = await Big3Common.Get('api/MyPage/StoreMgr/GetWithdrawlMessage');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                //조회 리스트 등록 및 저장 후 값 초기화 속성들 설정
                console.log(JSON.parse(Data.dataTable));
            }
        }
        catch (e) {
            console.log("CallWithdrawlMessageData", e);
        }
    }
    handleChange(event) {
        let checked = event.target.checked;
        this.setState({ Confirm_Yn: checked });
    }
    //회원탈퇴 처리
    async handleWithdrawal_Click() {
        try {
            let Data = await Big3Common.Get('api/MyPage/StoreMgr/SetWithdrawEnd');
            if (Data.codeName === Big3Common.ResultCode.Success) {
                this.RegisterSuccess = true;
                this.setState({ Content: "회원탈퇴 처리 되었습니다.<br/>다시 가입하시면 언제든지 사용하실 수 있습니다." });
                this.RegisterSuccess = true;
                Big3Common.ModalAlert(bootstrap, 'AlertBox');
            }
        }
        catch (e) {
            console.log("handleWithdrawal_Click", e);
        }
    }
    handleMove_Click() {
        if (this.RegisterSuccess) {
            Big3Common.Util.RemoveLoginStorage();
            window.location.href = "/Account/LoginMgr/Index";
        }
    }
    async handleAlert_Click() {
        if (this.state.Confirm_Yn === false) {
            this.setState({ Content: "회원탈퇴 확인을 체크하여 주세요." });
            Big3Common.ModalAlert(bootstrap, 'AlertBox');
            return false;
        }
        Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
    }
    render() {

        return (
            <>
                <div className="container_box p_b_margin c_padding">
                    <div className="Withdrawal_txt">탈퇴 전 반드시 확인 부탁드려요.</div>
                    <div className="Withdrawal_list">
                        <ul>
                            <li>거래정보가 있는 경우, 전자상거래 등에서의 소비자
                                보호에 관한 법률에 따라 계약 또는 청약철회에 관한
                                기록, 대금결제 및 재화 등의 공급에 관한 기록은
                                5년 동안 보존됩니다.</li>
                            <li>거래처에 보낸 메시지 등 일부 정보는 남아있을 수
                                있습니다.</li>
                            <li>클로디 서비스를 탈퇴하여도 기존 거래가 무효화되지 않습니다.</li>
                            <li>계정이 삭제된 후에는 계정을 살리거나 새로운 계정에 기존 데이터를 복구할 수 없습니다.</li>

                        </ul>
                    </div>
                    <div className="alarm_check">
                        <input className="form-check-input"
                            type="checkbox"
                            id="Confirm_Yn"
                            onChange={this.handleChange}
                            checked={this.state.Confirm_Yn}

                        />
                        <label className="form-check-label">
                            확인했습니다
                        </label>
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handleAlert_Click} >탈퇴하기</button>
                </div>
                <Alert
                    id="AlertBox"
                    title="회원탈퇴 안내"
                    content={this.state.Content}
                    AlertClick={this.handleMove_Click}
                />
                <Confirm
                    id="ConfirmBox"
                    title="회원탈퇴 안내"
                    content="정말로 탈퇴 하시겠습니까?"
                    ConfirmClick={(e) => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleWithdrawal_Click();
                    }}
                />
            </>
        );
    }
}
